import apiClient from './client';

export const appointmentsApi = {
  getAll: (params) => apiClient.get('/api/appointments', { params }),

  getById: (id) => apiClient.get(`/api/appointments/${id}`),

  create: (data) => apiClient.post('/api/appointments', data),

  update: (id, data) => apiClient.put(`/api/appointments/${id}`, data),

  delete: (id) => apiClient.delete(`/api/appointments/${id}`),

  cancel: (id, reason) => apiClient.post(`/api/appointments/${id}/cancel`, { reason }),

  confirm: (id) => apiClient.post(`/api/appointments/${id}/confirm`),

  complete: (id) => apiClient.post(`/api/appointments/${id}/complete`),

  reschedule: (id, data) => apiClient.post(`/api/appointments/${id}/reschedule`, data),

  getDetails: (id) => apiClient.get(`/api/appointments/${id}/details`),

  getUpcoming: (params) => apiClient.get('/api/appointments/upcoming', { params }),

  getToday: (params) => apiClient.get('/api/appointments/today', { params }),

  getSlots: (params) => apiClient.get('/api/appointments/slots', { params }),

  sendReminder: (id) => apiClient.post(`/api/appointments/${id}/reminder`),

  // Employees
  getEmployees: (params) => apiClient.get('/api/appointments/employees', { params }),

  getEmployeeById: (id) => apiClient.get(`/api/appointments/employees/${id}`),

  createEmployee: (data) => apiClient.post('/api/appointments/employees', data),

  updateEmployee: (id, data) => apiClient.put(`/api/appointments/employees/${id}`, data),

  deleteEmployee: (id) => apiClient.delete(`/api/appointments/employees/${id}`),

  getEmployeeDetails: (id) => apiClient.get(`/api/appointments/employees/${id}/details`),

  getEmployeeInformation: (id) => apiClient.get(`/api/appointments/employees/${id}/information`),

  // Branches
  getBranches: (params) => apiClient.get('/api/appointments/branches', { params }),

  getBranchById: (id) => apiClient.get(`/api/appointments/branches/${id}`),

  createBranch: (data) => apiClient.post('/api/appointments/branches', data),

  updateBranch: (id, data) => apiClient.put(`/api/appointments/branches/${id}`, data),

  deleteBranch: (id) => apiClient.delete(`/api/appointments/branches/${id}`),

  // User Information
  getUserInformation: (id) => apiClient.get(`/api/appointments/users/${id}/information`),
};

export default appointmentsApi;
